import constants from './constants'
import utils from './utils'

export const events = {
    API_READY: "api.API_READY",
    API_LOADING: "api.API_LOADING"
}

class API {
    static instance = null;

    constructor(props) {
        if(API.instance) return API.instance;
        API.instance = this;

        this.status = events.API_READY;
    }

    fetchFromApi = (endpoint, page) => {
        this.status = events.API_LOADING;
    
        if (!endpoint) {
            console.error("You must specify an API endpoint");
            this.status = events.API_READY;
            return;
        }
    
        // const HOURS = 24 * 60 * 60 * 1000;
        // const key = `${endpoint}:page${page}`;  // eg 'screen:page1' @sh
        // let url = 'http://dawna:123Dawna!@dev.mediajackagency.com/clients/dawna/row/wordpress/wp-json/wp/v2/' + endpoint + '?order=asc&per_page=100&page=' + page;
        let url = constants.WORDPRESS_HOME + "wp-json/wp/v2/" + endpoint + '?order=asc&per_page=100&page=' + page;
        if (!page) url = endpoint;
        this.status = events.API_READY;
        return fetch(url, {
            headers: utils.credHeaders()
        }).then((response) => {
            return response;
        })
            .catch((error) => {
                console.log("error ", error);
                this.status = events.API_READY;
            })
        //   });
    }
}

new API();

// todo: could use bindActionsCreats from redux ? https://blog.bam.tech/developer-news/4-ways-to-dispatch-actions-with-redux @jkr
export default API;